import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { MarcaProductoInterface } from "../../interfaces/marcaProductosInterfaces/MarcaProducto.interface";

export async function UpdateMarcaProductoAction(
  MarcaId: string,
  formData: FormData
): Promise<ApiResponse<MarcaProductoInterface>> {
  const { data } = await apiClient.patch<MarcaProductoInterface>(
    `/gpMarcaProductos/${MarcaId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return {
    status: 200,
    data,
    message: "Marca de productos actualizada correctamente",
  };
}
